import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'duration'
})
export class DurationPipe implements PipeTransform {

  transform(value: any, type?: any, format?: any): any {
    let duration: any = moment.duration(value, type);
    let formatted = null
    if (format)
      formatted = duration.format(format);
    else
      formatted = duration.format("hh:mm:ss");
    return formatted;
  }
}
